mutation UpdateStream($contentId: ID!, $input: UpdateStreamInput!) {
  updateStream(contentId: $contentId, input: $input) {
    id
  }
}
